import { Link, useLocation } from 'react-router-dom';
import { isRecord } from '../../services/errors';
import { tapLink } from '../../components/styles';
import AuthLayout from './AuthLayout';
import PasswordResetRequest from './PasswordResetRequest';

export default function ForgotPasswordPage() {
  const location = useLocation();
  // The login page passes along whatever email was already typed.
  const email = isRecord(location.state) && typeof location.state.email === 'string' ? location.state.email : '';

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a link to set a new one.">
      <PasswordResetRequest initialEmail={email} />
      <p className="mt-6 text-center">
        <Link to="/login" className={`${tapLink} text-primary font-medium hover:underline`}>
          Back to sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
